import React, { Suspense, FC, useCallback, useContext, useState, useMemo, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes, { string } from 'prop-types';
import classNames from 'classnames';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import Select from '../../../components/bootstrap/forms/Select';
import Option from '../../../components/bootstrap/Option';
import { useToasts } from 'react-toast-notifications';
import Toasts from '../../../components/bootstrap/Toasts';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
	loginArk,
	loginMfa,
	getUsers,
	getUser,
	getCurrencies,
	getCurrencyPolicyDetails,
	getConfiguration,
	checkCrmUser,
	getProfileInfo,
	getBanks,
	getUserById,
	getPermissionByGnericPolicy,
	verifyOTP,
	resendOtp,
	getPublicSettings,
	getCountry,
} from '../../../apis';
import AuthContext from '../../../contexts/authContext';
import { TModalFullScreen, TModalSize } from '../../../type/modal-type';

import Spinner from '../../../components/bootstrap/Spinner';
import Alert from '../../../components/bootstrap/Alert';
import Checks, { ChecksGroup } from '../../../components/bootstrap/forms/Checks';
import { useFormik } from 'formik';
import ConfigContext from '../../../contexts/configContext';
import useDarkMode from '../../../hooks/useDarkMode';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';
import { useLocation } from 'react-router-dom';
import DesktopIcon from '../../../assets/img/icons/desktop.svg';
import iphone from '../../../assets/img/icons/iphone.svg';
import Android from '../../../assets/img/icons/CAndroid.svg';
import webtraderIcon from '../../../assets/img/icons/webtrader.svg';

import { useTranslation } from 'react-i18next';
import { configure } from '@testing-library/react';
import { set } from 'date-fns';
// ... import all your 10 components
const LoginCustom1 = React.lazy(
	() => import('../../../components/custom/login/custom1/LoginCustom'),
);
const LoginCustom2 = React.lazy(
	() => import('../../../components/custom/login/custom2/LoginCustom'),
);

const componentMap: Record<string, React.ComponentType<any>> = {
	Company1: LoginCustom1,
	Company2: LoginCustom2,
	// ... more
};

interface Props {
	companyName: string;
	[key: string]: any;
}

interface LandingConfig {
	companyName: string;
	theme: {
		primaryColor: string;
		secondaryColor: string;
		textColor: string;
		inputBackground: string;
	};
}
const DynamicRegister: React.FC<Props> = ({ companyName, ...props }) => {
	const SelectedComponent = componentMap[companyName] || <></>;

	return <SelectedComponent {...props} />;
};

const Login: FC = () => {
	const location = useLocation();

	const queryParams = new URLSearchParams(location.search);
	const { t } = useTranslation('platform');
	const { darkModeStatus } = useDarkMode();
	const { setData, user, setDealerData } = useContext(AuthContext);
	const {
		setUsersData,
		setBanksData,
		setPublicSettingsData,
		setCurrenciesData,
		setCurrencyPolicyDetails,
	} = useContext(ConfigContext);
	const [rememberMe, setRememberMe] = useState<boolean>();
	const [userName, setuserName] = useState<string>();
	const [userPass, setUserPass] = useState<string>();
	const [DemoUserModal, setDemoUserModal] = useState(false);
	const [mfaModal, setMfaModal] = useState(false);
	const [verifyMobileModal, setVerifyMobileModal] = useState(false);
	const [landingConfig, setLandingConfig] = useState<LandingConfig | null>(null);
	const desktopTraderHandle = () => {
		window.open(`${process.env.REACT_APP_DESKTOPTRADER_LINK}`, '_blank');
	};
	const googlePlayHandle = () => {
		window.open(`${process.env.REACT_APP_GOOGLEPLAY_LINK}`, '_blank');
	};
	const appStoreHandle = () => {
		window.open(`${process.env.REACT_APP_APPSTORE_LINK}`, '_blank');
	};

	const [staticBackdropStatus, setStaticBackdropStatus] = useState(false);
	const [scrollableStatus, setScrollableStatus] = useState(false);
	const [centeredStatus, setCenteredStatus] = useState(false);
	const [sizeStatus, setSizeStatus] = useState<TModalSize>(null);
	const [fullScreenStatus, setFullScreenStatus] = useState<TModalFullScreen | undefined>(
		undefined,
	);
	const [animationStatus, setAnimationStatus] = useState(true);
	const [headerCloseStatus, setHeaderCloseStatus] = useState(true);
	const [showDownloadModal, setShowDownLoadModal] = useState(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isAdminLogin, setIsAdminLogin] = useState<boolean>(false);
	const [mfaLoading, setMfaLoading] = useState<boolean>(false);
	const { addToast } = useToasts();
	const [countryCode, setCountryCode] = useState<string>('');

	const initialStatus = () => {
		setStaticBackdropStatus(false);
		setScrollableStatus(false);
		setCenteredStatus(false);
		setSizeStatus(null);
		setFullScreenStatus(undefined);
		setAnimationStatus(true);
		setDemoUserModal(false);
		setHeaderCloseStatus(true);
	};
	const navigate = useNavigate();
	const handleClient = useCallback(() => navigate('/client'), [navigate]);
	const handleAdmin = useCallback(() => navigate('/admin'), [navigate]);
	const backgroundColor = darkModeStatus ? '#212529' : '#f8f9fa';
	const borderColor = darkModeStatus ? '#343a40' : '#f8f9fa';

	const getDeviceType = () => {
		const ua = navigator.userAgent;
		if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
			return 'tablet';
		}
		if (
			/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
				ua,
			)
		) {
			return 'mobile';
		}
		return 'CRM';
	};
	useEffect(() => {
		const fetchLandingConfig = async () => {
			try {
				const response = await fetch('/customLanding.json');
				if (!response.ok) {
					throw new Error('customLanding.json not found');
				}
				const data = await response.json();
				setLandingConfig(data);
			} catch (error) {
				console.warn('customLanding.json not found');
				setLandingConfig(null);
			}
		};

		fetchLandingConfig();
	}, []);
	useEffect(() => {
		const type = queryParams.get('type');
		if (type && type === 'First') {
			setShowDownLoadModal(true);
		}
		const rememberMe = localStorage.getItem('me');
		if (rememberMe === 'true') {
			setRememberMe(true);
		} else {
			setRememberMe(false);
		}
		setUserPass(localStorage.getItem('Ark_userPass') || '');
		setuserName(localStorage.getItem('Ark_userName') || '');
		initialStatus();
	}, []);
	const getUserData = useCallback(
		async (token: string) => {
			const data = await getUser(process.env.REACT_APP_ARKAPIURL, token);
			if (data.success) {
				setUsersData(data.data, true);
				return data.data[0].clientCurrencyPolicyId;
			}
			return;
		},
		[process.env.REACT_APP_ARKAPIURL],
	);
	
	const handleResetForms = () => {
		formik.resetForm();
		formik.setErrors({});
		MFAFormik.resetForm();
		verifyMobileFormik.resetForm();

		setIsLoading(false);
		setMfaLoading(false);
		setMfaModal(false);
		setVerifyMobileModal(false);
	};

	const getCurrencyPolicies = useCallback(
		async (policyId: number, userType: number, token: string) => {
			const data = await getCurrencyPolicyDetails(
				process.env.REACT_APP_ARKAPIURL,
				token,
				policyId,
				userType,
			);
			if (data.success) {
				setCurrencyPolicyDetails(data.data);
			}
		},
		[process.env.REACT_APP_ARKAPIURL],
	);
	const getUsersData = useCallback(
		async (token: string, userId: number | undefined) => {
			const banks = await getBanks(process.env.REACT_APP_ARKAPIURL, token);
			if (banks.success) {
				setBanksData(banks.data);
			}
			if (userId) {
				const data = await getUserById(process.env.REACT_APP_ARKAPIURL, token, userId);
				if (data.success) {
					const permission = await getPermissionByGnericPolicy(
						process.env.REACT_APP_ARKAPIURL,
						token,
						data.data.dealerGenericPolicy,
						3,
					);
					if (permission.success && permission.data && setDealerData) {
						setDealerData({ ...permission.data });
					}
					let users = await getUsers(process.env.REACT_APP_ARKAPIURL, token);
					if (users.success) {
						setUsersData(users.data, permission.data.canSeeClientNames);
					}
				}
			}
		},
		[process.env.REACT_APP_ARKAPIURL],
	);

	const getCurrenciesData = useCallback(
		async (token: string) => {
			const currencies = await getCurrencies(process.env.REACT_APP_ARKAPIURL, token);
			if (currencies.success) {
				setCurrenciesData(currencies.data);
			}
		},
		[process.env.REACT_APP_ARKAPIURL],
	);

	const getPublicSettingsData = useCallback(
		async (token: string | undefined) => {
			const data = await getPublicSettings(process.env.REACT_APP_ARKAPIURL, token);
			if (data.success) {
				setPublicSettingsData(data.data);
			}
		},
		[process.env.REACT_APP_ARKAPIURL],
	);
	const MFAFormik = useFormik({
		initialValues: {
			otp: '',
		},
		validate: (values) => {
			const errors: {
				otp?: string;
			} = {};
			if (!values.otp) {
				errors.otp = 'Required';
			}
			return errors;
		},
		onSubmit: async (values) => {
			setMfaLoading(true);
			// Implement your logic to handle OTP submission
			const arkbaseurl = process.env.REACT_APP_ARKAPIURL;
			const loginpost = {
				companyName: process.env.REACT_APP_COMPANY_NAME,
				userName: formik.values.loginUsername.trim(),
				password: formik.values.loginPassword,
				deviceType: getDeviceType(),
			};
			const data = await loginMfa(arkbaseurl, loginpost, values.otp);

			if (data.success === true) {
				setMfaLoading(false);
				getPublicSettingsData(data.data.token);
				if (data.data.demo) {
					setDemoUserModal(true);
				} else {
					if (data.data.userTypeId === 4) {
						setIsLoading(false);
						addToast(
							<Toasts title='Login Failed' icon='Error' time='Now' isDismiss>
								Can't login, departments are not allowed to login to CRM.
							</Toasts>,
							{
								autoDismiss: true,
							},
						);
					} else if (data.data.userTypeId === 1) {
						localStorage.setItem('me', String(formik.values.rememberMe));
						if (setData) {
							setData({
								...data.data,
								loginTime: data.timestamp || new Date().getTime(),
							});
						}
						await getCurrenciesData(data.data.token);
						const clientCurrencyPolicyId = await getUserData(data.data.token);
						if (clientCurrencyPolicyId) {
							await getCurrencyPolicies(clientCurrencyPolicyId, 1, data.data.token);
						}
						handleClient();
						setIsLoading(false);
					} else if (data.data.userTypeId === 2) {
						localStorage.setItem('me', String(formik.values.rememberMe));
						if (setData) {
							setData({
								...data.data,
								loginTime: data.timestamp || new Date().getTime(),
							});
						}
						await getUsersData(data.data.token, undefined);
						handleClient();
					} else if (data.data.userTypeId === 3) {
						localStorage.setItem('me', String(formik.values.rememberMe));
						if (setData) {
							setData({
								...data.data,
								loginTime: data.timestamp || new Date().getTime(),
							});
						}
						await getCurrenciesData(data.data.token);
						await getUsersData(data.data.token, data.data.id);
						handleAdmin();
					}
				}
			} else {
				setMfaLoading(false);
				addToast(
					<Toasts title='Login Failed' icon='Error' time='Now' isDismiss>
						{data?.message || 'Server Error'}
					</Toasts>,
					{
						autoDismiss: true,
					},
				);
			}
			handleResetForms();
		},
	});
	const verifyMobileFormik = useFormik({
		initialValues: {
			otp: '',
		},
		validate: (values) => {
			const errors: {
				otp?: string;
			} = {};
			if (!values.otp) {
				errors.otp = 'Required';
			}
			return errors;
		},
		onSubmit: async (values) => {
			setVerifyMobileModal(true);
			// Implement your logic to handle OTP submission
			const arkbaseurl = process.env.REACT_APP_ARKAPIURL;

			const data = await verifyOTP(arkbaseurl, {
				token: values.otp,
				username: formik.values.loginUsername.trim(),
			});
			if (data.success === true) {
				setVerifyMobileModal(false);
				addToast(
					<Toasts title='Success' icon='CheckCircle' iconColor='success' isDismiss>
						{data?.message ||
							'Mobile number verified successfully, please login again.'}
					</Toasts>,
					{ autoDismiss: true },
				);
			} else {
				setVerifyMobileModal(false);
				addToast(
					<Toasts title='Login Failed' icon='Error' time='Now' isDismiss>
						{data?.message || 'Server Error'}
					</Toasts>,
					{
						autoDismiss: true,
					},
				);
			}
			handleResetForms();
		},
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			loginUsername: rememberMe ? userName || '' : '',
			loginPassword: rememberMe ? userPass || '' : '',
			phoneNumber: '',
			rememberMe: rememberMe,
		},
		validate: (values) => {
			const errors: {
				loginUsername?: string;
				loginPassword?: string;
				phoneNumber?: string;
				rememberMe?: boolean;
			} = {};

			if (shouldUsePhoneLogin) {
				const cleanedPhone = (values.phoneNumber || '').replace(/[\s-]/g, '');
				const normalizedPhone = cleanedPhone.replace(/\D/g, '') || '';
				if (!normalizedPhone) {
					errors.phoneNumber = 'Phone number is required';
				} else if (
					!process.env.REACT_APP_STATIC_COUNTRY_CODE &&
					normalizedPhone.length < 7
				) {
					errors.phoneNumber = 'Phone number must include at least 7 digits';
				} else if (!/^\+?\d+$/.test(cleanedPhone)) {
					errors.phoneNumber = 'Phone number must contain digits only';
				}
			} else {
				if (!values.loginUsername) {
					errors.loginUsername = 'Required';
				}
			}

			if (!values.loginPassword) {
				errors.loginPassword = 'Required';
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: async (values) => {
			setIsLoading(true);
			const arkbaseurl = process.env.REACT_APP_ARKAPIURL;
			const loginpost = {
				companyName: process.env.REACT_APP_COMPANY_NAME,
				userName: shouldUsePhoneLogin
					? values.phoneNumber
					: values.loginUsername.trim(),
				password: values.loginPassword,
				deviceType: getDeviceType(),
			};
			const data = await loginArk(arkbaseurl, loginpost);
			if (data.success === true) {
				getPublicSettingsData(data.data.token);
				localStorage.setItem('me', String(values.rememberMe));
				if (values.rememberMe) {
					localStorage.setItem('Ark_userName', String(values.loginUsername));
					localStorage.setItem('Ark_userPass', String(values.loginPassword));
				} else {
					localStorage.removeItem('Ark_userPass');
					localStorage.removeItem('Ark_userName');
				}
				if (data.data.demo) {
					setIsLoading(false);
					setDemoUserModal(true);
				} else {
					if (data.data.userTypeId === 4) {
						setIsLoading(false);
						addToast(
							<Toasts title='Login Failed' icon='Error' time='Now' isDismiss>
								Can't login, departments are not allowed to login to CRM.
							</Toasts>,
							{
								autoDismiss: true,
							},
						);
					} else if (data.data.userTypeId === 1) {
						if (setData) {
							setData({
								...data.data,
								loginTime: data.timestamp || new Date().getTime(),
							});
						}
						await getCurrenciesData(data.data.token);
						const clientCurrencyPolicyId = await getUserData(data.data.token);
						if (clientCurrencyPolicyId) {
							getCurrencyPolicies(clientCurrencyPolicyId, 1, data.data.token);
						}
						handleClient();
						setIsLoading(false);
					} else if (data.data.userTypeId === 2) {
						if (setData) {
							setData({
								...data.data,
								loginTime: data.timestamp || new Date().getTime(),
							});
						}
						await getUsersData(data.data.token, undefined);
						// getCurrenciesData(data.data.token);
						handleClient();
						setIsLoading(false);
					} else if (data.data.userTypeId === 3) {
						if (setData) {
							setData({
								...data.data,
								loginTime: data.timestamp || new Date().getTime(),
							});
						}
						await getCurrenciesData(data.data.token);
						await getUsersData(data.data.token, data.data.id);
						handleAdmin();
						setIsLoading(false);
					}
				}
			} else {
				if (data?.errorCode === 'mobile.not.verified') {
					setVerifyMobileModal(true);
				} else if (data?.errorCode === 'required.otp.verification') {
					setMfaModal(true);
				} else {
					handleResetForms();
					addToast(
						<Toasts title='Login Failed' icon='Error' time='Now' isDismiss>
							{data?.message || 'Server Error'}
						</Toasts>,
						{
							autoDismiss: true,
						},
					);
				}
			}
		},
	});

	const handleResendCode = async () => {
		const data = await resendOtp(
			process.env.REACT_APP_ARKAPIURL,
			formik.values.loginUsername.trim(),
			2,
		);
		if (data.success === true) {
			addToast(
				<Toasts title='Success' icon='CheckCircle' iconColor='success' isDismiss>
					OTP Sent Successfully
				</Toasts>,
				{ autoDismiss: true },
			);
		} else {
			addToast(
				<Toasts title='Error' icon='Error' iconColor='danger' isDismiss>
					{data?.message || 'Failed to resend OTP'}
				</Toasts>,
				{ autoDismiss: true },
			);
		}
	};
	const handleCreateAccount = useCallback(
		(accountType: string) =>
			navigate(`/auth-pages/create-account/step1?accountType=${accountType}`),
		[navigate],
	);

	const handleForgotPassword = useCallback(() => {
		if (process.env.REACT_APP_EXTERNAL_FORGET_PW) {
			window.open(process.env.REACT_APP_EXTERNAL_FORGET_PW, '_blank');
		} else {
			navigate('/auth-pages/forgotpassword');
		}
	}, [navigate]);

	const handleKeyPress = (e: any) => {
		if (e.key === 'Enter') {
			formik.handleSubmit();
		}
	};
	useEffect(() => {
		const fetchCountryCode = async () => {
			try {
				const response = await getCountry();
				const detectedCountryCode =
					response?.country || response?.country_code || response?.countryCode;
				if (detectedCountryCode) {
					const normalizedCode = detectedCountryCode.toUpperCase();
					const country_code =
						process.env.REACT_APP_STATIC_COUNTRY_CODE || normalizedCode;
					setCountryCode(country_code);
				}
			} catch (error) {
				console.warn('Unable to detect country automatically', error);
				setCountryCode('IN');
			}
		};

		fetchCountryCode();
	}, []);
	const disableCountrySelect =
		process.env.REACT_APP_STATIC_COUNTRY_CODE !== undefined &&
		process.env.REACT_APP_STATIC_COUNTRY_CODE !== '';

	const hideUsername = process.env.REACT_APP_HIDE_USERNAME == "true";
	const shouldUsePhoneLogin = hideUsername && !isAdminLogin;
		
	return (
		<PageWrapper isProtected={false} title={'Login'} className={'bg-black'}>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					{process.env.REACT_APP_CUSTOM_LANDING_PAGE === undefined ||
					process.env.REACT_APP_CUSTOM_LANDING_PAGE == 'false' ? (
						<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
							<Card
								className='shadow-3d-dark'
								data-tour='login-page'
								style={{ backgroundColor: '#2a2d36' }}>
								<CardBody
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-l1-dark': darkModeStatus,
									})}>
									<div className='text-center my-5'>
										<Link
											to='/auth-pages/login'
											className={
												'text-decoration-none  fw-bold display-2 text-dark'
											}>
											<img src='/logo192.png' width={150} />
										</Link>
									</div>

									<div
										className={classNames(
											'text-center',
											'h1',
											'fw-bold',
											'mt-5',
											{
												'text-dark': !darkModeStatus,
												'text-white': darkModeStatus,
											},
										)}>
										Welcome,
									</div>
									<div className='text-center h4 text-muted mb-5'>
										Login to Your Account.
									</div>
									

									<form className='row g-4'>
										{shouldUsePhoneLogin ? (
											<div className='col-12'>
												<FormGroup
													id='phoneNumber'
													isFloating
													style={{ backgroundColor: 'transparent' }}>
													<PhoneInput
														country={countryCode.toLowerCase()}
														placeholder='Enter Mobile number'
														value={formik.values.phoneNumber}
														onBlur={formik.handleBlur}
														disableCountryCode={disableCountrySelect}
														disableCountryGuess={disableCountrySelect}
														disableDropdown={disableCountrySelect}
														onFocus={() => {
															formik.setErrors({});
														}}
														onChange={(value) =>
															formik.setFieldValue(
																'phoneNumber',
																value,
															)
														}
														inputStyle={{
															width: '100%',
															height: 'calc(3.5rem + 2px)',
															borderRadius: '1rem',
															border: '1px solid #f8f9fa',
															backgroundColor: backgroundColor,
															borderColor: borderColor,
														}}
													/>
													<Input
														type='hidden'
														autoComplete='phoneNumber'
														value={formik.values.phoneNumber}
														isTouched={formik.touched.phoneNumber}
														invalidFeedback={formik.errors.phoneNumber}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
											</div>
										) : (
											<div className='col-12'>
												<FormGroup
													id='loginUsername'
													isFloating
													label='Username'>
													<Input
														autoComplete='username'
														value={formik.values.loginUsername}
														isTouched={formik.touched.loginUsername}
														invalidFeedback={
															formik.errors.loginUsername
														}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
											</div>
										)}
										<div className='col-12' color={'dark'}>
											<FormGroup
												id='loginPassword'
												isFloating
												label='Password'
												color={'dark'}>
												<Input
													type='password'
													autoComplete='current-password'
													value={formik.values.loginPassword}
													isTouched={formik.touched.loginPassword}
													invalidFeedback={formik.errors.loginPassword}
													validFeedback='Looks good!'
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onKeyDown={handleKeyPress}
												/>
											</FormGroup>
										</div>

										<div className='col-12'>
											<div
												className={classNames(
													'd-flex',
													'flex-wrap',
													'align-items-center',
													'justify-content-between',
													'gap-3',
													{
														'text-dark': !darkModeStatus,
														'text-white': darkModeStatus,
													},
												)}>
												<Checks
													id='rememberMe'
													label='Remember Me'
													name='rememberMe'
													onChange={formik.handleChange}
													checked={formik.values.rememberMe}
												/>
												
												{process.env.REACT_APP_HIDE_FORGET_PASSWORD ===
													'false' && (
													<span
														className='ms-auto'
														style={{ cursor: 'pointer' }}
														onClick={handleForgotPassword}>
														Forgot password?
													</span>
												)}
											</div>
										</div>
										<div className='d-flex m-2 justify-content-center'>
											{hideUsername && (
													<div className='d-flex align-items-center gap-2 flex-wrap'>
														<span className='small text-muted'>
															{isAdminLogin
																? 'Switch back to client login'
																: 'Need to login as admin?'}
														</span>
														<Checks
															id='adminLoginToggle'
															type='switch'
															name='adminLoginToggle'
															ariaLabel='Admin login toggle'
															
															checked={isAdminLogin}
															onChange={() => {
																setIsAdminLogin((prev) => !prev);
																formik.setErrors({});
																formik.setTouched({});
															}}
														/>
													</div>
												)}
										</div>
										<div className='col-12'>
											<Button
												color='info'
												className='w-100 py-3'
												onClick={formik.handleSubmit}>
												{isLoading && <Spinner isSmall inButton isGrow />}
												Login
											</Button>
										</div>
									</form>
								</CardBody>
							</Card>

							<div className='text-center'>
								<span style={{ color: 'white' }}>
									Don't have an account? &#8196;
								</span>
								<span
									style={{ color: 'skyblue', cursor: 'pointer' }}
									className='rounded-1 w-100'
									onClick={() => {
										handleCreateAccount('real');
									}}>
									Create A Live Account
								</span>
							</div>
							
							{process.env.REACT_APP_DISABLE_DEMO_CREATION_LOGIN === 'false' && 

							<div className='text-center'>
								<span style={{ color: 'white' }}>Want To Test Drive? &#8196;</span>
								<span
									style={{ color: 'skyblue', cursor: 'pointer' }}
									className='rounded-1 w-100'
									onClick={() => {
										handleCreateAccount('demo');
									}}>
									Create A Demo Account
								</span>
							</div>
							}
						</div>
					) : (
						landingConfig != null && (
							<DynamicRegister
								companyName={landingConfig?.companyName || ''}
								formik={formik}
								hideUsername = {hideUsername}
								isAdminLogin = {isAdminLogin}
								setIsAdminLogin={()=>{setIsAdminLogin((prev) => !prev)}}
								countryCode = {countryCode}
								disableCountrySelect ={disableCountrySelect}
								isLoading={isLoading}
								handleForgotPassword={handleForgotPassword}
								handleCreateAccount={handleCreateAccount}
							/>
						)
					)}
					{/* # Demo Account Modal */}
					<Modal
						isOpen={DemoUserModal}
						setIsOpen={setDemoUserModal}
						titleId='DemoUserModal'
						isStaticBackdrop={staticBackdropStatus}
						isScrollable={scrollableStatus}
						isCentered={centeredStatus}
						size={sizeStatus}
						fullScreen={fullScreenStatus}
						isAnimation={animationStatus}>
						<ModalHeader setIsOpen={headerCloseStatus ? setDemoUserModal : undefined}>
							<ModalTitle id='DemoUserModal'>{'Account Login Failed'}</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<div className='row g-2'>
								<div className='col-12'>
									<FormGroup id='userName' isFloating color={'dark'}>
										<p>
											Can't login, demo Accounts are not allowed to login to
											CRM
										</p>
									</FormGroup>
								</div>
							</div>
						</ModalBody>
						<ModalFooter>
							<Button
								color='info'
								isOutline
								className='border-0'
								onClick={initialStatus}>
								{'close'}
							</Button>
						</ModalFooter>
					</Modal>
					{/* # MFA Mobile Modal */}
					<Modal
						isOpen={mfaModal}
						setIsOpen={setMfaModal}
						titleId='2fa'
						isCentered={true}>
						<ModalHeader>
							<ModalTitle id='2fa'>Enter Verification Code</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<div className='row g-4'>
								<FormGroup id='otp' isFloating label='6 Digits Code'>
									<Input
										id='otp'
										value={MFAFormik.values.otp}
										isTouched={MFAFormik.touched.otp}
										invalidFeedback={MFAFormik.errors.otp}
										isValid={MFAFormik.isValid}
										onChange={MFAFormik.handleChange}
										onBlur={MFAFormik.handleBlur}
										onFocus={() => {
											MFAFormik.setErrors({});
										}}
									/>
								</FormGroup>
								<div className='col-12'>
									<Button
										color='info'
										className='w-100 py-3'
										onClick={MFAFormik.handleSubmit}>
										{mfaLoading && <Spinner isSmall inButton isGrow />}
										Verify
									</Button>
								</div>
							</div>
						</ModalBody>
					</Modal>
					{/* # Verify Mobile Modal */}
					<Modal
						isOpen={verifyMobileModal}
						setIsOpen={setVerifyMobileModal}
						titleId='verifyMobile'
						isCentered={true}>
						<ModalHeader>
							<ModalTitle id='verifyMobile'>Enter Verification Code</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<div className='row g-4'>
								<FormGroup id='otp' isFloating label='6 Digits Code'>
									<Input
										id='otp'
										value={verifyMobileFormik.values.otp}
										isTouched={verifyMobileFormik.touched.otp}
										invalidFeedback={verifyMobileFormik.errors.otp}
										isValid={verifyMobileFormik.isValid}
										onChange={verifyMobileFormik.handleChange}
										onBlur={verifyMobileFormik.handleBlur}
										onFocus={() => {
											verifyMobileFormik.setErrors({});
										}}
									/>
								</FormGroup>
								<div className='col-12 d-flex flex-row gap-4'>
									<Button
										color='info'
										isOutline
										className='w-100 py-3'
										onClick={handleResendCode}>
										{t('Resend Code')}
									</Button>
									<Button
										color='info'
										className='w-100 py-3'
										onClick={verifyMobileFormik.handleSubmit}>
										{mfaLoading && <Spinner isSmall inButton isGrow />}
										Verify
									</Button>
								</div>
							</div>
						</ModalBody>
					</Modal>
					{/* # Platforms Download Modal */}
					<Modal
						isOpen={showDownloadModal}
						setIsOpen={() => {}}
						size={'lg'}
						titleId='DownloadPlatform'
						isCentered={true}>
						<ModalHeader>
							<ModalTitle id='DownloadPlatform'>Platforms Download</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<div className=' d-flex flex-column justify-content-center gap-4 p-4'>
								<div className='h-100 d-flex flex-row align-items-center gap-4 '>
									<img
										style={{ cursor: 'pointer' }}
										src={Android}
										className='m-2'
									/>
									<div className='d-flex justify-content-between align-items-center w-100 gap-4'>
										<p style={{ margin: '0px' }}>
											{t(process.env.REACT_APP_COMPANY_NAME + ' for Android')}
										</p>
										<Link
											style={{ cursor: 'default' }}
											to=''
											color='white'
											onClick={googlePlayHandle}>
											<Button color='primary'>{t('Download')}</Button>
										</Link>
									</div>
								</div>
								<div className='h-100 d-flex flex-row align-items-center  gap-4 '>
									<img
										style={{ cursor: 'pointer' }}
										src={iphone}
										className='m-2'
									/>
									<div className='d-flex justify-content-between align-items-center  w-100 gap-4'>
										<p style={{ margin: '0px' }}>
											{t(process.env.REACT_APP_COMPANY_NAME + ' for IOS')}
										</p>
										<Link
											style={{ cursor: 'default' }}
											to=''
											color='white'
											onClick={appStoreHandle}>
											<Button color='primary'>{t('Download')}</Button>
										</Link>
									</div>
								</div>
								<div className='d-flex flex-row align-items-center gap-4 '>
									<img
										style={{ cursor: 'pointer' }}
										src={DesktopIcon}
										className='m-2'
									/>
									<div className='d-flex align-items-center justify-content-between  w-100 gap-4'>
										<p style={{ margin: '0px' }}>
											{t(process.env.REACT_APP_COMPANY_NAME + ' for Windows')}
										</p>
										<Link
											style={{ cursor: 'default' }}
											to=''
											color='white'
											onClick={desktopTraderHandle}>
											<Button color='primary'>{t('Download')}</Button>
										</Link>
									</div>
								</div>
								<div
									className='p-4 shadow rounded text-white'
									style={{ background: '#51D2F9' }}>
									{t('PlatformNote')}
								</div>
							</div>
						</ModalBody>
						<ModalFooter>
							<div className='mx-4'>
								<Button
									color='info'
									isOutline
									className='border-0'
									onClick={() => {
										setShowDownLoadModal(false);
										navigate('/auth-pages/login');
									}}>
									Close
								</Button>
							</div>
						</ModalFooter>
					</Modal>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default Login;
